import * as React from 'react';
import Links from './Links/Links';
import Mobile from '@/components/Footer/LAFooter/Mobile/Mobile';
import styled from 'styled-components';

const WhiteLabelFooter = () => {
    return (
        <StyledFooter>
            <Mobile />
            <Links />
        </StyledFooter>
    );
};

export default React.memo(WhiteLabelFooter);

const StyledFooter = styled.div`
    @media print {
        display: none;
    }
`;
